import { render } from "./SoftwareForm.vue?vue&type=template&id=483ab710&scoped=true"
import script from "./SoftwareForm.vue?vue&type=script&lang=js"
export * from "./SoftwareForm.vue?vue&type=script&lang=js"

import "./SoftwareForm.vue?vue&type=style&index=0&id=483ab710&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483ab710"]])

export default __exports__